import axios from 'axios';
import * as Sentry from "@sentry/react";

// Create axios instance with dynamic baseURL
const apiClient = axios.create({
  headers: {
    'Content-Type': 'application/json',
  },
});

// Update baseURL dynamically before each request
apiClient.interceptors.request.use((config) => {
  // Import BASE_URL and BACKEND_URLS fresh each time to get the latest value
  const { BASE_URL, BACKEND_URLS } = require('../Utils/APIConstants');
  
  // Force production backend for all billing/payment endpoints
  if (config.url?.includes('/billing/') || 
      config.url?.includes('/subscriptions') ||
      config.url?.includes('/payments')) {
    config.baseURL = BACKEND_URLS.PRODUCTION;
    console.log('💳 Billing API Request forced to production:', config.baseURL + config.url);
  } else {
    config.baseURL = BASE_URL;
    console.log('🔗 API Request to:', config.baseURL + config.url);
  }
  
  return config;
});

// Add response interceptor for error tracking
apiClient.interceptors.response.use(
  response => response,
  error => {
    // Capture API errors in Sentry
    Sentry.captureException(error, {
      contexts: {
        api: {
          endpoint: error.config?.url,
          method: error.config?.method,
          status: error.response?.status,
          statusText: error.response?.statusText,
        },
      },
      tags: {
        error_type: 'api_error',
        endpoint: error.config?.url,
        method: error.config?.method,
      },
      extra: {
        requestData: error.config?.data,
        responseData: error.response?.data,
        headers: error.config?.headers,
      }
    });
    
    return Promise.reject(error);
  }
);

// Function to dynamically set Authorization header
const setAuthToken = (token) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
};

export const ApiService = {
    setAuthToken, // Expose the setAuthToken method
    post: (url, data, isMultipart = false) => {
  const headers = isMultipart
    ? { 'Content-Type': 'multipart/form-data' }
    : { 'Content-Type': 'application/json' };

  return apiClient.post(url, data, { headers });
},
  get: (url, params) => apiClient.get(url, { params }),
  put: (url, data) => apiClient.put(url, data),
  patch: (url, data) => apiClient.patch(url, data),
  delete: (url) => apiClient.delete(url),
  upload: (url, formData) => {
  return apiClient.put(url, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
};
